import type { Padding } from '@ui/types/base/padding'

const paddingMap: Record<Padding, string> = {
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-6',
  none: 'p-0'
}

export const usePadding = (padding: Padding) => paddingMap[padding]
